import styled from 'styled-components';

export const PillBar = styled.div`
  display: flex;
  gap: 4px;
`;

export const PillButton = styled.button`
  background: ${p => (p.$active ? p.theme.colors.purple50 : 'transparent')};
  border: 1px solid ${p => (p.$active ? p.theme.colors.purple400 : p.theme.colors.gray300)};
  border-radius: 6px;
  color: ${p => (p.$active ? p.theme.colors.purple400 : p.theme.colors.gray500)};
  cursor: pointer;
  font-size: var(--font-size-reduced);
  padding: 4px 10px;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    border-color: ${p => p.theme.colors.purple400};
    color: ${p => p.theme.colors.purple400};
  }

  i {
    margin-right: 4px;
  }
`;

export const DataCard = styled.div`
  background: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray300};
  border-radius: 8px;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;

  scrollbar-width: thin;
  scrollbar-color: ${p => p.theme.colors.gray300} transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${p => p.theme.colors.gray300};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${p => p.theme.colors.gray400};
  }
`;

export const DataTable = styled.table`
  border-collapse: collapse;
  font-size: var(--font-size-base);
  width: 100%;

  th {
    background: ${p => p.theme.colors.gray50};
    border-bottom: 1px solid ${p => p.theme.colors.gray300};
    color: ${p => p.theme.colors.gray600};
    font-weight: ${p => p.theme.fontWeight.medium};
    padding: 8px 12px;
    position: sticky;
    text-align: left;
    top: 0;
    z-index: 1;
  }

  td {
    border-bottom: 1px solid ${p => p.theme.colors.gray200};
    color: ${p => p.theme.colors.gray800};
    padding: 8px 12px;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: ${p => p.theme.colors.gray50};
  }
`;
